import axios from 'axios'
import router from "@/router";
import ViewUI from 'view-design';

/** axios 请求连接等待时间 **/
axios.defaults.timeout = 300000
axios.defaults.withCredentials=true
axios.defaults.crossDomain=true

/** axios Request 配置 **/
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
/** axios Response 配置 **/
axios.interceptors.response.use(
  response => {
      if(response.data.code == 401) {
          let redirectUrl = window.location.href
          let loginMode = process.env.LOGIN_MODE

          if (loginMode === 'local') {
              window.location.href = "/#/login?redirect=" + encodeURIComponent(redirectUrl)
          } else {
              // 使用oauth2登录模式
              window.location.href = "/#/oauth2-login?redirect=" + encodeURIComponent(redirectUrl)
          }
      }
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

export default axios